import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/search/actionTypes';

import { updateAirportSearch } from './utils';

export default function* listenUpdateAirportSearch() {
  yield takeEvery(actionTypes.UPDATE_AIRPORT_SEARCH, updateAirportSearch);
}
